/**
 * 远程信令连接页面模块。
 */
import { useCallback, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import Menu from "@/components/remote/menu";
import ConnectDeviceCard from "./components/connect-device-card";
import InvitationCard from "./components/invitation-card";
import useSignalConnection from "./use-signal-connection";

/**
 * 信令连接页面组件，负责协调表单与连接逻辑
 */
const SignalConnector = () => {
	const navigate = useNavigate();

	const {
		connectionSummary,
		currentRoomId,
		shouldShowInvitation,
		shouldShowLoading,
		isError,
		errorMessage,
		submitCredentials,
		cancelConnection,
		tryAutoConnectFromLink,
		formDefaults,
		linkPrefill,
	} = useSignalConnection();

	// 如 URL 携带邀请信息，补齐表单，并触发自动连接（Hook 内部会处理状态切换）
	useEffect(() => {
		tryAutoConnectFromLink(window.location.href);
	}, [tryAutoConnectFromLink]);

	const handleStartRemote = useCallback(() => {
		if (!currentRoomId) {
			toast.error("Please connect to the device first");
			return;
		}
		navigate("/dashboard");
	}, [currentRoomId, navigate]);

	const connectorContent = shouldShowInvitation ? (
		<InvitationCard
			summary={connectionSummary}
			onStartRemote={handleStartRemote}
			onCancel={cancelConnection}
		/>
	) : (
		<ConnectDeviceCard
			defaultDeviceId={formDefaults.deviceId}
			defaultPassCode={formDefaults.passCode}
			defaultLinkValue={linkPrefill}
			onSubmit={submitCredentials}
			isLoading={shouldShowLoading}
			showError={isError}
			errorMessage={errorMessage}
		/>
	);

	return (
		<>
			<Menu />
			<div className="relative flex flex-1 bg-slate-900">
				<div className="absolute inset-0 bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 opacity-90" />
				<div className="absolute inset-0 bg-[radial-gradient(circle_at_top,rgba(59,130,246,0.25),transparent_45%)]" />
				<div className="relative z-10 flex w-full flex-1 items-center justify-center px-4 py-8 sm:py-12">
					<div className="w-full max-w-xl">{connectorContent}</div>
				</div>
			</div>
		</>
	);
};

export default SignalConnector;
